const getCurrency = () => {
  return JSON.parse(localStorage.getItem("currentUser"))?.user?.defaultCurrency || "£";
};

export default getCurrency;
